export class ProductosTable {
  public static productos: any = [{
    id: 1,
    nombre: "Sinergial Full",
    descripcion: "Jaxbean",
    familia: {id: 1, nombre: "Sinergial"}
  }, {
    id: 2,
    nombre: "Sinergial Lite",
    descripcion: "Feedmix",
    familia: {id: 1, nombre: "Sinergial"}
  }]
}